var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQUlEQVR42mMY5oAx+NwZECZbM4PFBDAGscnTrJkPwnBDyNGMYQhZmjENodyANJoagA8TNoAARhiAB6QRg4dRfgEAb2N4sU7vq0UAAAAASUVORK5CYII=";
  export default img;